export default __webpack_public_path__ + "static/media/LotteCinima.c536c84d.jpg";